import React from 'react';
import { BrowserRouter } from 'react-router-dom';

import { createRoot } from 'react-dom/client';
import { ThemeProvider } from 'styled-components';

import { theme } from '@notino/react-styleguide-v20';

import { enableRequestInterception } from '@env';
import { GlobalStyle } from '@sharedComponents';
import { isDevEnv } from '@utils/development';

import { AppLayout } from './AppLayout';

const app = async () => {
  if (isDevEnv() && enableRequestInterception) {
    await import('./utils/development/serviceWorker/serviceWorkerInstall').then((mod) => mod.serviceWorkerInstall());
  }

  await Promise.resolve();
};

await app().finally(() => {
  const container = document.getElementById('app');

  if (!container) {
    return;
  }

  const root = createRoot(container);

  root.render(
    <>
      <GlobalStyle />
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <AppLayout />
        </BrowserRouter>
      </ThemeProvider>
    </>,
  );
});
